import * as React from "react";
import { Calendar } from "lucide-react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

export interface DateFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {}

export const DateField = React.forwardRef<HTMLInputElement, DateFieldProps>(
  ({ className, onClick, onFocus, onKeyDown, ...props }, ref) => {
    const inputRef = React.useRef<HTMLInputElement>(null);

    React.useImperativeHandle(ref, () => inputRef.current as HTMLInputElement);

    const openPicker = (e?: React.SyntheticEvent) => {
      // showPicker requer gesto do usuário; tentar e, se falhar, apenas focar
      try {
        // Apenas tenta chamar se veio de um evento confiável de usuário
        const trusted = (e as any)?.nativeEvent?.isTrusted;
        if ((inputRef.current as any)?.showPicker && trusted) {
          (inputRef.current as any).showPicker();
        } else {
          inputRef.current?.focus();
        }
      } catch (_err) {
        inputRef.current?.focus();
      }
    };

    return (
      <div
        className="relative w-full"
        onClick={(e) => {
          openPicker(e as any);
          onClick?.(e as any);
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            openPicker(e as any);
          }
          onKeyDown?.(e as any);
        }}
      >
        <Input
          ref={inputRef}
          type="date"
          className={cn("pr-10 date-no-native-icon", className)}
          onFocus={(e) => {
            // Não abrir automaticamente no foco para evitar erro de user gesture; apenas propagar
            onFocus?.(e);
          }}
          onClick={(e) => {
            // Evita que o clique no input seja capturado duas vezes pelo wrapper
            e.stopPropagation();
            openPicker(e);
          }}
          {...props}
        />
        <button
          type="button"
          aria-label="Abrir calendário"
          className="absolute inset-y-0 right-2 my-auto h-8 w-8 grid place-items-center text-muted-foreground hover:text-foreground"
          onClick={(e) => {
            e.stopPropagation();
            openPicker(e as any);
          }}
          tabIndex={-1}
        >
          <Calendar className="h-4 w-4" />
        </button>
      </div>
    );
  }
);

DateField.displayName = "DateField";
